module.exports = __webpack_public_path__ + "img/piknik-logo-white.5e9f2fda.svg";